import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ReactPlayer from 'react-player';
import captureVideoFrame from 'capture-video-frame';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { ImageType } from '../../common/constants';
import FixedCropper from './image/FixedCropper';
import { Sleep } from '../../common/util';
import apiService from '../../services.js/apiService';

const VideoCropperModal = (
  {
    videoUrl,
    reviewId,
    postId,
    setThumbnailAsImage,
    showVideo,
    handleShowVideo,
    onCropSuccess,
  },
) => {
  let player;

  // const [showVideo, setShowVideo] = useState(false);
  const [capturedThumbnail, setCapturedThumbnail] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [hasThumbnail, setHasThumbnail] = useState(false);
  const [hasSeek, setHasSeek] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [src, setSrc] = useState(null);
  const [thumbnailURL, setThumbnailURL] = useState(null);

  // Track if the user has crop the video thumbnail
  const [hasCropThumbnail, setHasCropThumbnail] = useState(false);

  const handleCloseCropper = () => {
    setShowCropper(false);
    setSrc(null);
    handleShowVideo(true);
    // setShowVideo(true);
  };

  const handleClose = () => {
    if (hasCropThumbnail) {
      // setShowVideo(false);
      setHasCropThumbnail(false);
      handleShowVideo(false);
      setCapturedThumbnail(null);
      setHasSeek(false);
      setThumbnailFile(null);
      setThumbnailURL(null);
      setHasThumbnail(false);
      setSrc(null);
      setShowCropper(false);
    } else {
      toast.error('Video thumbnail must be set');
    }
  };

  const onUploadThumbnail = async (file) => {
    try {
      if (file) {
        setThumbnailURL(null);
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageType', ImageType.VideoThumbnail);
        let cloudfrontLink;

        if (reviewId) {
          cloudfrontLink = await apiService.uploadReviewMedia(reviewId, formData, file);
        } else {
          cloudfrontLink = await apiService.uploadPostMedia(postId, formData, file);
        }

        setThumbnailURL(`${cloudfrontLink}?${Math.random()}`);
        setShowCropper(false);
        setCapturedThumbnail(null);
        setHasThumbnail(true);
        setHasCropThumbnail(true);
        handleShowVideo(true);
        // setShowVideo(true);
        onCropSuccess(videoUrl);
        await Sleep(200);
        setThumbnailAsImage(cloudfrontLink);
      }
    } catch (error) {
      console.log(`media.js > onUploadThumbnail:`, error);
      toast.error('Error occurs in uploading thumbnail.please contact admin.');
    }
  };

  const onCaptureThumbnail = () => {
    const frame = captureVideoFrame(player.getInternalPlayer());
    setCapturedThumbnail(frame);
    setThumbnailURL(frame.dataUri);
    setHasThumbnail(true);
  };

  const handleSaveThumbnail = async () => {
    try {
      const file = new File(
        [capturedThumbnail.blob],
        `${(videoUrl.split('/')[videoUrl.split('/').length - 1]).split('.')[0]}.jpg`,
        { type: 'image/jpeg' },
      );

      if (file) {
        setShowCropper(true);
        // setShowVideo(false);
        handleShowVideo(false);
        setThumbnailFile(file);

        await Sleep(200);
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          setSrc(reader.result);
          setHasThumbnail(false);
        });
        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.log(`media.js > handleSaveThumbnail:`, error);
      toast.error('Error occurs in saving thumbnail.please contact admin.');
    }
  };

  return (
    <>
      <Dialog
        id="videoDialog"
        fullWidth
        maxWidth="md"
        open={showVideo}
        onClose={handleClose}
      >
        <DialogTitle disableTypography style={{ height: 0, marginBottom: -20 }}>
          <IconButton
            onClick={handleClose}
            style={{ float: 'right', marginTop: -20, marginRight: -20 }}
          >
            <CloseIcon style={{ height: 15, width: 15 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={
            {
              display:             'grid',
              gridTemplateColumns: 'repeat(4, 2fr)',
              gridColumnGap:       capturedThumbnail ? 50 : 120,
              margin:              10,
              marginLeft:          30,
            }
          }
          >
            <div style={{ textAlign: 'center' }}>
              <ReactPlayer
                ref={(ref) => { player = ref; }}
                url={videoUrl}
                playing={!hasSeek}
                controls
                width={400}
                height={250}
                onSeek={() => setHasSeek(true)}
                volume={0}
                config={{
                  file: {
                    attributes: {
                      crossOrigin: 'anonymous',
                    },
                  },
                }}
              />
              <Button
                onClick={onCaptureThumbnail}
                style={{ width: 225, marginTop: 10, marginBottom: 10 }}
                variant="contained"
                color="secondary"
              >
                Capture frame as thumbnail
              </Button>
            </div>
            {hasThumbnail
              ? (
                <div style={{ textAlign: 'center' }}>
                  <img src={thumbnailURL} style={{ marginTop: 12, maxWidth: capturedThumbnail ? 405 : 280 }} alt="" />
                  {capturedThumbnail
                    ? (
                      <Button
                        onClick={handleSaveThumbnail}
                        style={{ width: 225, marginTop: 20, marginBottom: 10 }}
                        variant="contained"
                        color="secondary"
                      >
                        Crop & Save Thumbnail
                      </Button>
                    ) : null}
                </div>
              )
              : (
                <ReactPlayer
                  url={videoUrl}
                  width={400}
                  height={250}
                  style={{ marginLeft: -70 }}
                  config={{
                    file: {
                      attributes: {
                        crossOrigin: 'anonymous',
                      },
                    },
                  }}
                />
              )}
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen
        open={showCropper}
        onClose={handleCloseCropper}
      >
        <FixedCropper
          width={4}
          height={3}
          cropPixelWidth={400}
          cropPixelHeight={400}
          outputPixelWidth={900}
          outputPixelHeight={900}
          type="upload"
          src={src}
          file={thumbnailFile}
          fileName={`${(videoUrl.split('/')[videoUrl.split('/').length - 1]).split('.')[0]}.jpg`}
          handleSave={onUploadThumbnail}
          handleClose={handleCloseCropper}
          isCropping
        />
      </Dialog>
    </>
  );
};
export default VideoCropperModal;

VideoCropperModal.propTypes = {
  showVideo:       PropTypes.bool.isRequired,
  handleShowVideo: PropTypes.func.isRequired,
  videoUrl:        PropTypes.string,
  reviewId:        PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  postId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setThumbnailAsImage: PropTypes.func,
  onCropSuccess:       PropTypes.func,
};

VideoCropperModal.defaultProps = {
  videoUrl:            '',
  reviewId:            null,
  postId:              null,
  setThumbnailAsImage: () => {},
  onCropSuccess:       (_videoUrl) => {},
};
